var map = {
	"./__language": [
		"0f65",
		7,
		"chunk-2d0af86b"
	],
	"./__language.js": [
		"0f65",
		7,
		"chunk-2d0af86b"
	],
	"./en/add-address/add-address": [
		"916e",
		7,
		"chunk-2d0e48fd"
	],
	"./en/add-address/add-address.js": [
		"916e",
		7,
		"chunk-2d0e48fd"
	],
	"./en/address-list/address-list": [
		"519f",
		7,
		"chunk-2d0c77df"
	],
	"./en/address-list/address-list.js": [
		"519f",
		7,
		"chunk-2d0c77df"
	],
	"./en/apply-detail/apply-detail": [
		"5547",
		7,
		"chunk-2d0c8619"
	],
	"./en/apply-detail/apply-detail.js": [
		"5547",
		7,
		"chunk-2d0c8619"
	],
	"./en/apply-refund/apply-refund": [
		"7be4",
		7,
		"chunk-2d0e1db0"
	],
	"./en/apply-refund/apply-refund.js": [
		"7be4",
		7,
		"chunk-2d0e1db0"
	],
	"./en/cart/cart": [
		"5315",
		7,
		"chunk-2d0c7e38"
	],
	"./en/cart/cart.js": [
		"5315",
		7,
		"chunk-2d0c7e38"
	],
	"./en/confirm-order/confirm-order": [
		"6a0e",
		7,
		"chunk-2d0d9f56"
	],
	"./en/confirm-order/confirm-order.js": [
		"6a0e",
		7,
		"chunk-2d0d9f56"
	],
	"./en/download-app/download-app": [
		"c7de",
		7,
		"chunk-2d217cab"
	],
	"./en/download-app/download-app.js": [
		"c7de",
		7,
		"chunk-2d217cab"
	],
	"./en/general-invite-landing-v2/general-invite-landing-v2": [
		"e034",
		7,
		"chunk-2d224502"
	],
	"./en/general-invite-landing-v2/general-invite-landing-v2.js": [
		"e034",
		7,
		"chunk-2d224502"
	],
	"./en/general-invite-landing/general-invite-landing": [
		"8996",
		7,
		"chunk-2d0df2d4"
	],
	"./en/general-invite-landing/general-invite-landing.js": [
		"8996",
		7,
		"chunk-2d0df2d4"
	],
	"./en/general-invite/general-invite": [
		"a64c",
		7,
		"chunk-2d208a5a"
	],
	"./en/general-invite/general-invite.js": [
		"a64c",
		7,
		"chunk-2d208a5a"
	],
	"./en/gift-after-invitation/gift-after-invitation": [
		"9504",
		7,
		"chunk-2d0e5716"
	],
	"./en/gift-after-invitation/gift-after-invitation.js": [
		"9504",
		7,
		"chunk-2d0e5716"
	],
	"./en/global/global": [
		"8d03",
		7
	],
	"./en/global/global.js": [
		"8d03",
		7
	],
	"./en/help-center-v2/help-center-v2": [
		"2d14",
		7,
		"chunk-2d0bd90b"
	],
	"./en/help-center-v2/help-center-v2.js": [
		"2d14",
		7,
		"chunk-2d0bd90b"
	],
	"./en/help-center/help-center": [
		"ef17",
		7,
		"chunk-2d230f7d"
	],
	"./en/help-center/help-center.js": [
		"ef17",
		7,
		"chunk-2d230f7d"
	],
	"./en/immediately-transfer/immediately-transfer": [
		"c9de",
		7,
		"chunk-2d21842d"
	],
	"./en/immediately-transfer/immediately-transfer.js": [
		"c9de",
		7,
		"chunk-2d21842d"
	],
	"./en/invitation-code/invitation-code": [
		"025e",
		7,
		"chunk-2d0a3548"
	],
	"./en/invitation-code/invitation-code.js": [
		"025e",
		7,
		"chunk-2d0a3548"
	],
	"./en/invitation-record/invitation-record": [
		"836d",
		7,
		"chunk-2d0ddc1f"
	],
	"./en/invitation-record/invitation-record.js": [
		"836d",
		7,
		"chunk-2d0ddc1f"
	],
	"./en/invitation-share/invitation-share": [
		"9388",
		7,
		"chunk-2d0e5090"
	],
	"./en/invitation-share/invitation-share.js": [
		"9388",
		7,
		"chunk-2d0e5090"
	],
	"./en/invite-events/invite-events": [
		"38a0",
		7,
		"chunk-2d0bae0a"
	],
	"./en/invite-events/invite-events.js": [
		"38a0",
		7,
		"chunk-2d0bae0a"
	],
	"./en/legal-policies/legal-policies": [
		"9164",
		7,
		"chunk-2d0e48cc"
	],
	"./en/legal-policies/legal-policies.js": [
		"9164",
		7,
		"chunk-2d0e48cc"
	],
	"./en/login-verification-code/login-verification-code": [
		"bc15",
		7,
		"chunk-2d21a71b"
	],
	"./en/login-verification-code/login-verification-code.js": [
		"bc15",
		7,
		"chunk-2d21a71b"
	],
	"./en/login/login": [
		"d1de",
		7,
		"chunk-2d21da84"
	],
	"./en/login/login.js": [
		"d1de",
		7,
		"chunk-2d21da84"
	],
	"./en/logout-notice/logout-notice": [
		"dbaa",
		7,
		"chunk-2d229214"
	],
	"./en/logout-notice/logout-notice.js": [
		"dbaa",
		7,
		"chunk-2d229214"
	],
	"./en/may-invite/may-invite": [
		"dff0",
		7,
		"chunk-2d22a182"
	],
	"./en/may-invite/may-invite.js": [
		"dff0",
		7,
		"chunk-2d22a182"
	],
	"./en/order-detail/order-detail": [
		"99fb",
		7,
		"chunk-fa7794ac"
	],
	"./en/order-detail/order-detail.js": [
		"99fb",
		7,
		"chunk-fa7794ac"
	],
	"./en/order-list/order-list": [
		"374b",
		7,
		"chunk-2d0ba508"
	],
	"./en/order-list/order-list.js": [
		"374b",
		7,
		"chunk-2d0ba508"
	],
	"./en/order-remark/order-remark": [
		"6d7f",
		7,
		"chunk-2d0dab73"
	],
	"./en/order-remark/order-remark.js": [
		"6d7f",
		7,
		"chunk-2d0dab73"
	],
	"./en/order-select-coupon/order-select-coupon": [
		"31b3",
		9,
		"chunk-2d0b93e5"
	],
	"./en/order-select-coupon/order-select-coupon.js": [
		"31b3",
		9,
		"chunk-2d0b93e5"
	],
	"./en/pay-result/pay-result": [
		"370c",
		7,
		"chunk-2d0ba48d"
	],
	"./en/pay-result/pay-result.js": [
		"370c",
		7,
		"chunk-2d0ba48d"
	],
	"./en/privacy-policy/privacy-policy": [
		"f65f",
		7,
		"chunk-2d22d057"
	],
	"./en/privacy-policy/privacy-policy.js": [
		"f65f",
		7,
		"chunk-2d22d057"
	],
	"./en/promote-apply/promote-apply": [
		"6044",
		7,
		"chunk-2d0ce7b0"
	],
	"./en/promote-apply/promote-apply.js": [
		"6044",
		7,
		"chunk-2d0ce7b0"
	],
	"./en/promoter-page/promoter-page": [
		"f823",
		7,
		"chunk-2d22d749"
	],
	"./en/promoter-page/promoter-page.js": [
		"f823",
		7,
		"chunk-2d22d749"
	],
	"./en/register/register": [
		"f363",
		7,
		"chunk-2d22c500"
	],
	"./en/register/register.js": [
		"f363",
		7,
		"chunk-2d22c500"
	],
	"./en/select-address-province/select-address-province": [
		"dafa",
		7,
		"chunk-2d228eee"
	],
	"./en/select-address-province/select-address-province.js": [
		"dafa",
		7,
		"chunk-2d228eee"
	],
	"./en/select-address/select-address": [
		"4675",
		7,
		"chunk-2d0c15d6"
	],
	"./en/select-address/select-address.js": [
		"4675",
		7,
		"chunk-2d0c15d6"
	],
	"./en/select-coupon-v2/select-coupon-v2": [
		"0b84",
		9,
		"chunk-2d0ae9a4"
	],
	"./en/select-coupon-v2/select-coupon-v2.js": [
		"0b84",
		9,
		"chunk-2d0ae9a4"
	],
	"./en/select-coupon/select-coupon": [
		"5701",
		7,
		"chunk-2d0c8d19"
	],
	"./en/select-coupon/select-coupon.js": [
		"5701",
		7,
		"chunk-2d0c8d19"
	],
	"./en/set-invitation-code/set-invitation-code": [
		"ff92",
		7,
		"chunk-2d2384cf"
	],
	"./en/set-invitation-code/set-invitation-code.js": [
		"ff92",
		7,
		"chunk-2d2384cf"
	],
	"./en/transfer-help/transfer-help": [
		"59b6",
		7,
		"chunk-2d0c9aae"
	],
	"./en/transfer-help/transfer-help.js": [
		"59b6",
		7,
		"chunk-2d0c9aae"
	],
	"./en/transfer-payment/transfer-payment": [
		"0a5e",
		7,
		"chunk-2d0ae5b7"
	],
	"./en/transfer-payment/transfer-payment.js": [
		"0a5e",
		7,
		"chunk-2d0ae5b7"
	],
	"./en/treasure-login/treasure-login": [
		"5d716",
		7,
		"chunk-7499a537"
	],
	"./en/treasure-login/treasure-login.js": [
		"5d716",
		7,
		"chunk-7499a537"
	],
	"./en/treasureLogin-verification-code/treasureLogin-verification-code": [
		"b110",
		7,
		"chunk-2d20eb64"
	],
	"./en/treasureLogin-verification-code/treasureLogin-verification-code.js": [
		"b110",
		7,
		"chunk-2d20eb64"
	],
	"./export-language": [
		"3607",
		7,
		"chunk-4468475e",
		"chunk-5b98aa08",
		"chunk-17d8865c"
	],
	"./export-language.js": [
		"3607",
		7,
		"chunk-4468475e",
		"chunk-5b98aa08",
		"chunk-17d8865c"
	],
	"./import-language": [
		"f963",
		7,
		"chunk-4468475e",
		"chunk-5b98aa08",
		"chunk-32167fff"
	],
	"./import-language.js": [
		"f963",
		7,
		"chunk-4468475e",
		"chunk-5b98aa08",
		"chunk-32167fff"
	],
	"./km/add-address/add-address": [
		"6d48",
		7,
		"chunk-2d0daae8"
	],
	"./km/add-address/add-address.js": [
		"6d48",
		7,
		"chunk-2d0daae8"
	],
	"./km/address-list/address-list": [
		"da35",
		7,
		"chunk-2d228895"
	],
	"./km/address-list/address-list.js": [
		"da35",
		7,
		"chunk-2d228895"
	],
	"./km/apply-detail/apply-detail": [
		"e673",
		7,
		"chunk-2d225c03"
	],
	"./km/apply-detail/apply-detail.js": [
		"e673",
		7,
		"chunk-2d225c03"
	],
	"./km/apply-refund/apply-refund": [
		"9217",
		7,
		"chunk-2d0e4bf5"
	],
	"./km/apply-refund/apply-refund.js": [
		"9217",
		7,
		"chunk-2d0e4bf5"
	],
	"./km/cart/cart": [
		"ab14",
		7,
		"chunk-2d212efa"
	],
	"./km/cart/cart.js": [
		"ab14",
		7,
		"chunk-2d212efa"
	],
	"./km/confirm-order/confirm-order": [
		"cc8d",
		7,
		"chunk-2d221c82"
	],
	"./km/confirm-order/confirm-order.js": [
		"cc8d",
		7,
		"chunk-2d221c82"
	],
	"./km/download-app/download-app": [
		"8237",
		7,
		"chunk-2d0dd7d4"
	],
	"./km/download-app/download-app.js": [
		"8237",
		7,
		"chunk-2d0dd7d4"
	],
	"./km/general-invite-landing-v2/general-invite-landing-v2": [
		"3ffd",
		7,
		"chunk-2d0c5b87"
	],
	"./km/general-invite-landing-v2/general-invite-landing-v2.js": [
		"3ffd",
		7,
		"chunk-2d0c5b87"
	],
	"./km/general-invite-landing/general-invite-landing": [
		"7730",
		7,
		"chunk-2d0d7633"
	],
	"./km/general-invite-landing/general-invite-landing.js": [
		"7730",
		7,
		"chunk-2d0d7633"
	],
	"./km/general-invite/general-invite": [
		"8c33",
		7,
		"chunk-2d0e8fc1"
	],
	"./km/general-invite/general-invite.js": [
		"8c33",
		7,
		"chunk-2d0e8fc1"
	],
	"./km/gift-after-invitation/gift-after-invitation": [
		"0950",
		7,
		"chunk-2d0a4f5a"
	],
	"./km/gift-after-invitation/gift-after-invitation.js": [
		"0950",
		7,
		"chunk-2d0a4f5a"
	],
	"./km/global/global": [
		"857e",
		7
	],
	"./km/global/global.js": [
		"857e",
		7
	],
	"./km/help-center-v2/help-center-v2": [
		"c642",
		7,
		"chunk-2d2172e7"
	],
	"./km/help-center-v2/help-center-v2.js": [
		"c642",
		7,
		"chunk-2d2172e7"
	],
	"./km/help-center/help-center": [
		"c0cf",
		7,
		"chunk-2d216246"
	],
	"./km/help-center/help-center.js": [
		"c0cf",
		7,
		"chunk-2d216246"
	],
	"./km/immediately-transfer/immediately-transfer": [
		"85b7",
		7,
		"chunk-2d0de8c8"
	],
	"./km/immediately-transfer/immediately-transfer.js": [
		"85b7",
		7,
		"chunk-2d0de8c8"
	],
	"./km/invitation-code/invitation-code": [
		"231a",
		7,
		"chunk-2d0b2147"
	],
	"./km/invitation-code/invitation-code.js": [
		"231a",
		7,
		"chunk-2d0b2147"
	],
	"./km/invitation-record/invitation-record": [
		"9455",
		7,
		"chunk-2d0e53f1"
	],
	"./km/invitation-record/invitation-record.js": [
		"9455",
		7,
		"chunk-2d0e53f1"
	],
	"./km/invitation-share/invitation-share": [
		"6699",
		7,
		"chunk-2d0cfed6"
	],
	"./km/invitation-share/invitation-share.js": [
		"6699",
		7,
		"chunk-2d0cfed6"
	],
	"./km/invite-events/invite-events": [
		"436f",
		7,
		"chunk-2d0c0aa5"
	],
	"./km/invite-events/invite-events.js": [
		"436f",
		7,
		"chunk-2d0c0aa5"
	],
	"./km/legal-policies/legal-policies": [
		"286f",
		7,
		"chunk-2d0b34ac"
	],
	"./km/legal-policies/legal-policies.js": [
		"286f",
		7,
		"chunk-2d0b34ac"
	],
	"./km/login-verification-code/login-verification-code": [
		"0540",
		7,
		"chunk-2d0a4037"
	],
	"./km/login-verification-code/login-verification-code.js": [
		"0540",
		7,
		"chunk-2d0a4037"
	],
	"./km/login/login": [
		"d9f0",
		7,
		"chunk-2d21f895"
	],
	"./km/login/login.js": [
		"d9f0",
		7,
		"chunk-2d21f895"
	],
	"./km/logout-notice/logout-notice": [
		"6042",
		7,
		"chunk-2d0ce7ae"
	],
	"./km/logout-notice/logout-notice.js": [
		"6042",
		7,
		"chunk-2d0ce7ae"
	],
	"./km/may-invite/may-invite": [
		"c7ee",
		7,
		"chunk-2d217cca"
	],
	"./km/may-invite/may-invite.js": [
		"c7ee",
		7,
		"chunk-2d217cca"
	],
	"./km/order-detail/order-detail": [
		"644f",
		7,
		"chunk-706cd816"
	],
	"./km/order-detail/order-detail.js": [
		"644f",
		7,
		"chunk-706cd816"
	],
	"./km/order-list/order-list": [
		"1eef",
		7,
		"chunk-2d0b6eeb"
	],
	"./km/order-list/order-list.js": [
		"1eef",
		7,
		"chunk-2d0b6eeb"
	],
	"./km/order-remark/order-remark": [
		"09f1",
		7,
		"chunk-2d0a554a"
	],
	"./km/order-remark/order-remark.js": [
		"09f1",
		7,
		"chunk-2d0a554a"
	],
	"./km/order-select-coupon/order-select-coupon": [
		"be55",
		9,
		"chunk-2d21af19"
	],
	"./km/order-select-coupon/order-select-coupon.js": [
		"be55",
		9,
		"chunk-2d21af19"
	],
	"./km/pay-result/pay-result": [
		"8935",
		7,
		"chunk-2d0df219"
	],
	"./km/pay-result/pay-result.js": [
		"8935",
		7,
		"chunk-2d0df219"
	],
	"./km/privacy-policy/privacy-policy": [
		"ae37",
		7,
		"chunk-2d213a7e"
	],
	"./km/privacy-policy/privacy-policy.js": [
		"ae37",
		7,
		"chunk-2d213a7e"
	],
	"./km/promote-apply/promote-apply": [
		"0a0e",
		7,
		"chunk-2d0ae51c"
	],
	"./km/promote-apply/promote-apply.js": [
		"0a0e",
		7,
		"chunk-2d0ae51c"
	],
	"./km/promoter-page/promoter-page": [
		"5eda",
		7,
		"chunk-2d0d4043"
	],
	"./km/promoter-page/promoter-page.js": [
		"5eda",
		7,
		"chunk-2d0d4043"
	],
	"./km/register/register": [
		"09a2",
		7,
		"chunk-2d0a54b0"
	],
	"./km/register/register.js": [
		"09a2",
		7,
		"chunk-2d0a54b0"
	],
	"./km/select-address-province/select-address-province": [
		"cc20",
		7,
		"chunk-2d221b94"
	],
	"./km/select-address-province/select-address-province.js": [
		"cc20",
		7,
		"chunk-2d221b94"
	],
	"./km/select-address/select-address": [
		"b644",
		7,
		"chunk-2d20fe8a"
	],
	"./km/select-address/select-address.js": [
		"b644",
		7,
		"chunk-2d20fe8a"
	],
	"./km/select-coupon-v2/select-coupon-v2": [
		"ed4e",
		9,
		"chunk-2d230886"
	],
	"./km/select-coupon-v2/select-coupon-v2.js": [
		"ed4e",
		9,
		"chunk-2d230886"
	],
	"./km/select-coupon/select-coupon": [
		"2394",
		7,
		"chunk-2d0b2212"
	],
	"./km/select-coupon/select-coupon.js": [
		"2394",
		7,
		"chunk-2d0b2212"
	],
	"./km/set-invitation-code/set-invitation-code": [
		"aeaa",
		7,
		"chunk-2d21403a"
	],
	"./km/set-invitation-code/set-invitation-code.js": [
		"aeaa",
		7,
		"chunk-2d21403a"
	],
	"./km/transfer-help/transfer-help": [
		"3aa5",
		7,
		"chunk-2d0c47f8"
	],
	"./km/transfer-help/transfer-help.js": [
		"3aa5",
		7,
		"chunk-2d0c47f8"
	],
	"./km/transfer-payment/transfer-payment": [
		"ca9b",
		7,
		"chunk-2d22151d"
	],
	"./km/transfer-payment/transfer-payment.js": [
		"ca9b",
		7,
		"chunk-2d22151d"
	],
	"./km/treasure-login/treasure-login": [
		"0c1a",
		7,
		"chunk-2d0aecb9"
	],
	"./km/treasure-login/treasure-login.js": [
		"0c1a",
		7,
		"chunk-2d0aecb9"
	],
	"./km/treasureLogin-verification-code/treasureLogin-verification-code": [
		"3d86",
		7,
		"chunk-2d0c4e45"
	],
	"./km/treasureLogin-verification-code/treasureLogin-verification-code.js": [
		"3d86",
		7,
		"chunk-2d0c4e45"
	],
	"./language": [
		"3789",
		9
	],
	"./language.js": [
		"3789",
		9
	],
	"./zh/add-address/add-address": [
		"1c9f",
		7,
		"chunk-2d0b6215"
	],
	"./zh/add-address/add-address.js": [
		"1c9f",
		7,
		"chunk-2d0b6215"
	],
	"./zh/address-list/address-list": [
		"3f76",
		7,
		"chunk-2d0c55a8"
	],
	"./zh/address-list/address-list.js": [
		"3f76",
		7,
		"chunk-2d0c55a8"
	],
	"./zh/apply-detail/apply-detail": [
		"44c9",
		7,
		"chunk-2d0c13ac"
	],
	"./zh/apply-detail/apply-detail.js": [
		"44c9",
		7,
		"chunk-2d0c13ac"
	],
	"./zh/apply-refund/apply-refund": [
		"9f3a",
		7,
		"chunk-2d0f0f91"
	],
	"./zh/apply-refund/apply-refund.js": [
		"9f3a",
		7,
		"chunk-2d0f0f91"
	],
	"./zh/cart/cart": [
		"9864",
		7,
		"chunk-2d0e6313"
	],
	"./zh/cart/cart.js": [
		"9864",
		7,
		"chunk-2d0e6313"
	],
	"./zh/confirm-order/confirm-order": [
		"2b96",
		7,
		"chunk-2d0bd283"
	],
	"./zh/confirm-order/confirm-order.js": [
		"2b96",
		7,
		"chunk-2d0bd283"
	],
	"./zh/download-app/download-app": [
		"dc80",
		7,
		"chunk-2d2290ad"
	],
	"./zh/download-app/download-app.js": [
		"dc80",
		7,
		"chunk-2d2290ad"
	],
	"./zh/general-invite-landing-v2/general-invite-landing-v2": [
		"81cf",
		7,
		"chunk-2d0dda12"
	],
	"./zh/general-invite-landing-v2/general-invite-landing-v2.js": [
		"81cf",
		7,
		"chunk-2d0dda12"
	],
	"./zh/general-invite-landing/general-invite-landing": [
		"56ce",
		7,
		"chunk-2d0c8fb9"
	],
	"./zh/general-invite-landing/general-invite-landing.js": [
		"56ce",
		7,
		"chunk-2d0c8fb9"
	],
	"./zh/general-invite/general-invite": [
		"7a12",
		7,
		"chunk-2d0e13a1"
	],
	"./zh/general-invite/general-invite.js": [
		"7a12",
		7,
		"chunk-2d0e13a1"
	],
	"./zh/gift-after-invitation/gift-after-invitation": [
		"9586",
		7,
		"chunk-2d0e5810"
	],
	"./zh/gift-after-invitation/gift-after-invitation.js": [
		"9586",
		7,
		"chunk-2d0e5810"
	],
	"./zh/global/global": [
		"07bf",
		7
	],
	"./zh/global/global.js": [
		"07bf",
		7
	],
	"./zh/help-center-v2/help-center-v2": [
		"3eb0",
		7,
		"chunk-2d0c5716"
	],
	"./zh/help-center-v2/help-center-v2.js": [
		"3eb0",
		7,
		"chunk-2d0c5716"
	],
	"./zh/help-center/help-center": [
		"b175",
		7,
		"chunk-2d20ec23"
	],
	"./zh/help-center/help-center.js": [
		"b175",
		7,
		"chunk-2d20ec23"
	],
	"./zh/immediately-transfer/immediately-transfer": [
		"ab18",
		7,
		"chunk-2d212efe"
	],
	"./zh/immediately-transfer/immediately-transfer.js": [
		"ab18",
		7,
		"chunk-2d212efe"
	],
	"./zh/invitation-code/invitation-code": [
		"6f73",
		7,
		"chunk-2d0db2c2"
	],
	"./zh/invitation-code/invitation-code.js": [
		"6f73",
		7,
		"chunk-2d0db2c2"
	],
	"./zh/invitation-record/invitation-record": [
		"3cdb",
		7,
		"chunk-2d0c5004"
	],
	"./zh/invitation-record/invitation-record.js": [
		"3cdb",
		7,
		"chunk-2d0c5004"
	],
	"./zh/invitation-share/invitation-share": [
		"002d",
		7,
		"chunk-2d0a2d68"
	],
	"./zh/invitation-share/invitation-share.js": [
		"002d",
		7,
		"chunk-2d0a2d68"
	],
	"./zh/invite-events/invite-events": [
		"0b06",
		7,
		"chunk-2d0ae8ae"
	],
	"./zh/invite-events/invite-events.js": [
		"0b06",
		7,
		"chunk-2d0ae8ae"
	],
	"./zh/legal-policies/legal-policies": [
		"e54c",
		7,
		"chunk-2d225815"
	],
	"./zh/legal-policies/legal-policies copy": [
		"b652",
		7,
		"chunk-2d20fea7"
	],
	"./zh/legal-policies/legal-policies copy.js": [
		"b652",
		7,
		"chunk-2d20fea7"
	],
	"./zh/legal-policies/legal-policies.js": [
		"e54c",
		7,
		"chunk-2d225815"
	],
	"./zh/login-verification-code/login-verification-code": [
		"1114",
		7,
		"chunk-2d0aa539"
	],
	"./zh/login-verification-code/login-verification-code.js": [
		"1114",
		7,
		"chunk-2d0aa539"
	],
	"./zh/login/login": [
		"6243",
		7,
		"chunk-2d0cef31"
	],
	"./zh/login/login.js": [
		"6243",
		7,
		"chunk-2d0cef31"
	],
	"./zh/logout-notice/logout-notice": [
		"a37b",
		7,
		"chunk-2d207f73"
	],
	"./zh/logout-notice/logout-notice.js": [
		"a37b",
		7,
		"chunk-2d207f73"
	],
	"./zh/may-invite/may-invite": [
		"944f",
		7,
		"chunk-2d0e5403"
	],
	"./zh/may-invite/may-invite.js": [
		"944f",
		7,
		"chunk-2d0e5403"
	],
	"./zh/order-detail/order-detail": [
		"2798",
		7,
		"chunk-10fede62"
	],
	"./zh/order-detail/order-detail.js": [
		"2798",
		7,
		"chunk-10fede62"
	],
	"./zh/order-list/order-list": [
		"25f2",
		7,
		"chunk-2d0b2f05"
	],
	"./zh/order-list/order-list.js": [
		"25f2",
		7,
		"chunk-2d0b2f05"
	],
	"./zh/order-remark/order-remark": [
		"badc",
		7,
		"chunk-2d21a5f4"
	],
	"./zh/order-remark/order-remark.js": [
		"badc",
		7,
		"chunk-2d21a5f4"
	],
	"./zh/order-select-coupon/order-select-coupon": [
		"ce1a",
		9,
		"chunk-2d222328"
	],
	"./zh/order-select-coupon/order-select-coupon.js": [
		"ce1a",
		9,
		"chunk-2d222328"
	],
	"./zh/pay-result/pay-result": [
		"f16e",
		7,
		"chunk-2d22bdb0"
	],
	"./zh/pay-result/pay-result.js": [
		"f16e",
		7,
		"chunk-2d22bdb0"
	],
	"./zh/privacy-policy/privacy-policy": [
		"ea6d",
		7,
		"chunk-2d22fd80"
	],
	"./zh/privacy-policy/privacy-policy.js": [
		"ea6d",
		7,
		"chunk-2d22fd80"
	],
	"./zh/promote-apply/promote-apply": [
		"a1cc",
		7,
		"chunk-2d207d46"
	],
	"./zh/promote-apply/promote-apply.js": [
		"a1cc",
		7,
		"chunk-2d207d46"
	],
	"./zh/promoter-page/promoter-page": [
		"cf3a",
		7,
		"chunk-2d222727"
	],
	"./zh/promoter-page/promoter-page.js": [
		"cf3a",
		7,
		"chunk-2d222727"
	],
	"./zh/register/register": [
		"f9b6",
		7,
		"chunk-2d22e0dd"
	],
	"./zh/register/register.js": [
		"f9b6",
		7,
		"chunk-2d22e0dd"
	],
	"./zh/select-address-province/select-address-province": [
		"8e0d",
		7,
		"chunk-2d0e9717"
	],
	"./zh/select-address-province/select-address-province.js": [
		"8e0d",
		7,
		"chunk-2d0e9717"
	],
	"./zh/select-address/select-address": [
		"f1b3",
		7,
		"chunk-2d22c2d2"
	],
	"./zh/select-address/select-address.js": [
		"f1b3",
		7,
		"chunk-2d22c2d2"
	],
	"./zh/select-coupon-v2/select-coupon-v2": [
		"3f8a",
		9,
		"chunk-2d0c55f2"
	],
	"./zh/select-coupon-v2/select-coupon-v2.js": [
		"3f8a",
		9,
		"chunk-2d0c55f2"
	],
	"./zh/select-coupon/select-coupon": [
		"184a",
		7,
		"chunk-2d0ac00a"
	],
	"./zh/select-coupon/select-coupon.js": [
		"184a",
		7,
		"chunk-2d0ac00a"
	],
	"./zh/set-invitation-code/set-invitation-code": [
		"2f58",
		7,
		"chunk-2d0be10d"
	],
	"./zh/set-invitation-code/set-invitation-code.js": [
		"2f58",
		7,
		"chunk-2d0be10d"
	],
	"./zh/transfer-help/transfer-help": [
		"0335",
		7,
		"chunk-2d0a389b"
	],
	"./zh/transfer-help/transfer-help.js": [
		"0335",
		7,
		"chunk-2d0a389b"
	],
	"./zh/transfer-payment/transfer-payment": [
		"c2ad",
		7,
		"chunk-2d216988"
	],
	"./zh/transfer-payment/transfer-payment.js": [
		"c2ad",
		7,
		"chunk-2d216988"
	],
	"./zh/treasure-login/treasure-login": [
		"1c8c",
		7,
		"chunk-2d0b61f3"
	],
	"./zh/treasure-login/treasure-login.js": [
		"1c8c",
		7,
		"chunk-2d0b61f3"
	],
	"./zh/treasureLogin-verification-code/treasureLogin-verification-code": [
		"ca93",
		7,
		"chunk-2d2214ee"
	],
	"./zh/treasureLogin-verification-code/treasureLogin-verification-code.js": [
		"ca93",
		7,
		"chunk-2d2214ee"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "fa6a";
module.exports = webpackAsyncContext;